import React, { useEffect } from 'react';
import { getEffectiveScheme, useThemeStore } from './themeStore';

type Props = {
    children: React.ReactNode;
};

export function ThemeProvider({ children }: Props) {
    const setPreference = useThemeStore((s) => s.setPreference);

    // NOTE: Theme switching is currently disabled
    // We are not using themes in our app at this time, so system theme changes
    // will not affect the app. The app will always use the light theme.
    // In the future, when we implement theme support, we will enable this functionality.

    // Hydrate preference from storage (but always force to 'light' for now)
    useEffect(() => {
        (async () => {
            // Force preference to 'light' - themes are disabled
            setPreference('light');
            // Don't load from storage since we're forcing light theme
            // const saved = await asyncStorage.getItem(THEME_PREFERENCE_STORAGE_KEY);
            // if (saved === 'light' || saved === 'dark' || saved === 'system') {
            //     setPreference(saved);
            // }
        })();
    }, [setPreference]);

    // DISABLED: Subscribe to OS scheme changes
    // System theme changes are disabled - app always uses light theme
    // When themes are enabled in the future, uncomment this:
    // useEffect(() => {
    //     const sub = Appearance.addChangeListener(({ colorScheme }) => {
    //         setSystemScheme((colorScheme ?? 'light') as NonNullable<ColorSchemeName>);
    //     });
    //     return () => sub.remove();
    // }, [setSystemScheme]);

    // Provide current scheme via React context if needed in the future
    // For now, just renders children as store is globally accessible.
    return <>{children}</>;
}

export function useThemeScheme(): 'light' | 'dark' {
    const preference = useThemeStore((s) => s.preference);
    const systemScheme = useThemeStore((s) => s.systemScheme);
    return getEffectiveScheme(preference, systemScheme);
}


